<template>
  <div>
    <div class="uk-width-large uk-margin-auto">
      <div class="uk-card uk-card-default">
        <div class="uk-card-header">
          <h3 class="uk-card-title uk-margin-remove-bottom uk-text-center">Emergency Details</h3>
        </div>
        <div class="uk-card-body">
          <ValidationObserver ref="observer" tag="div" class="uk-form-stacked">
            <div class="uk-margin">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <label class="uk-form-label" for="info" :class="{ 'uk-text-danger': errors.length }">Emergency Description <span class="input-label-required">*</span></label>
                <div class="uk-form-controls">
                  <textarea id="info" v-model="emergency.description" class="uk-textarea" :class="{ 'uk-form-danger': errors.length }" rows="3" name="info" data-cy="textarea-description" />
                </div>
                <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="uk-margin">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <label class="uk-form-label" for="info" :class="{ 'uk-text-danger': errors.length }">Complaint <span class="input-label-required">*</span></label>
                <div class="uk-form-controls">
                  <multiselect v-model="emergency.complaints" :class="{ 'multiselect-error': errors.length }" placeholder="Pick at least one. Type to filter." label="value" track-by="id" :options="complaints" :multiple="true" :searchable="true" :hide-selected="true" data-cy="select-complaints" />
                </div>
                <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="uk-margin">
              <ValidationProvider v-slot="{ errors }">
                <label class="uk-form-label" for="info" :class="{ 'uk-text-danger': errors.length }">Required Practice Features</label>
                <div class="uk-form-controls checkbox-group">
                  <template v-for="feature in practiceFeatures">
                    <label :key="feature.id"><input :id="`checkbox-${feature.value}`" v-model="emergency.features" class="uk-checkbox" type="checkbox" :value="feature.id" data-cy="checkbox-feature"> {{ feature.value }}</label>
                  </template>
                </div>
                <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="uk-margin">
              <ValidationProvider v-slot="{ errors }" :rules="{ required: true, min_value: 9.99, max_value: 99.99 }">
                <label class="uk-form-label" for="price" :class="{ 'uk-text-danger': errors.length }">Price <span class="input-label-required">*</span></label>
                <div class="uk-form-controls">
                  <currency-input ref="price" v-model="price" currency="GBP" :value-range="{ min: 9.99, max: 99.99 }" class="uk-input" data-cy="input-price" />
                </div>
                <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </ValidationObserver>
        </div>
        <div class="uk-card-footer uk-text-center">
          <button class="uk-button uk-button-primary" data-cy="button-next" @click="next">Next</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { CurrencyInput, parseCurrency } from 'vue-currency-input'

export default {
  name: 'ComponentAppointmentCreateEmergency',

  components: { ValidationProvider, ValidationObserver, CurrencyInput },

  props: {
    description: {
      type: String,
      required: false,
      default: null
    }
  },

  data() {
    return {
      price: 45.00,
      emergency: {
        description: null,
        complaints: [],
        features: []
      }
    }
  },

  computed: {
    complaints() {
      return this.$helpers.complaints
    },

    practiceFeatures() {
      return this.$helpers.practiceFeatures
    },

    parsedPrice() {
      return parseCurrency(this.$refs.price.formattedValue, { currency: 'GBP', valueAsInteger: true })
      // OR using the instance method:
      // return this.$parseCurrency(this.value, this.options)
    }
  },

  created() {
    if (this.description) {
      this.emergency.description = this.description
    }
  },

  methods: {
    async next() {
      const isValid = await this.$refs.observer.validate()

      const data = {
        price: this.parsedPrice,
        emergency: { ...this.emergency }, // Assign is used to disable reactivity because the data is modified couple of lines below
        features: this.features
      }

      data.emergency.complaints = data.emergency.complaints.map(({ id }) => id)

      if (isValid) {
        this.$bus.$emit('appointment-section-complete', { type: 'emergency', data })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-group {
  display: flex;
  flex-direction: column;
}
</style>
